import React, { useRef, useState } from 'react';

import styles from './VideoPlayer.module.scss';
import classnames from 'classnames/bind';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const CN = 'video-player';
const videoClassName = `${CN}__video`;
const playButtonClassName = `${CN}__play-button`;

const cx = classnames.bind(styles);

interface VideoPlayerProps {
    url: string;
    posterUrl: string;
    autoplay?: boolean;
    muted?: boolean;
    loop?: boolean;
    className?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  url,
  posterUrl,
  className = '',
  autoplay = false,
  muted = false,
  loop = false
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [ playing, setPlaying ] = useState(autoplay);

  const handleVideo = (): void => {
    if (videoRef.current) {
      if (playing) {
        videoRef.current.pause();
        setPlaying(false);
      } else {
        videoRef.current.play();
        setPlaying(true);
      }
    }
  };

  return <div className={ cx(CN, className) }>
    <video
      className={ cx(videoClassName) }
      autoPlay={ autoplay }
      muted={ muted }
      loop={ loop }
      src={ url }
      poster={ posterUrl }
      ref={ videoRef }
      onClick={ handleVideo }
    />
    { !playing && <PlayCircleOutlineIcon className={ cx(playButtonClassName) } fontSize='medium' onClick={ handleVideo }/>}
  </div>;
};
